import React, { useState } from 'react';
import showAlert from '../../../common/utils/alert';
import UpdateEnvConstantValue from './UpdateEnvConstantValue';
import TooltipInfo from '../../../common/docs/TooltipInfo';
import { description } from '../../../common/utils/event_constants';

const ShowEnvConstantTable = ({
  envId,
  projectId,
  version,
  constant,
  appSetting,
  actions,
  deleteFlag,
}) => {
  const [showForm, setShowForm] = useState(false);
  const handleSubmit = (constantValue) => {
    actions
      .updateEnvConstant({ envId, projectId, version, uuid: constant.uuid, value: constantValue })
      .then(() => {
        setShowForm(false);
        window.location.reload();
      });
  };
  const deleteEnvConstant = () => {
    const preConfirm = () => {
      actions.removeEnvConstant({ envId, projectId, version, uuid: constant.uuid }).then(() => {
        window.location.reload();
      });
    };
    showAlert('This will remove key from all the environments', preConfirm, 'Yes, delete it!');
  };
  const showEnvConstantFormTable = (constant) => {
    const { updateEnvConstantPending } = appSetting;
    return (
      <UpdateEnvConstantValue
        constant={constant}
        showForm={showForm}
        setShowForm={() => setShowForm(!showForm)}
        handleSubmit={handleSubmit}
        updateEnvConstantPending={updateEnvConstantPending}
      />
    );
  };

  const showConstantValue = () => {
    if (!constant.value) {
      return '';
    }

    return (
      <textarea
        className="w-100 p-2"
        disabled
        rows={constant.value.length / 30}
        value={constant.value}
      ></textarea>
    );
  };
  return (
    <tr key={constant.name}>
      <td width="25%">{constant.name}</td>
      <td width="50%">{showConstantValue()}</td>
      <td width="20%">
        {showEnvConstantFormTable(constant)}
        <button className="btn btn-xs btn-theme-submit" onClick={() => setShowForm(!showForm)}>
          <i className="wb webconnect-pencil"> </i>
        </button>
        &nbsp;
        {constant.isExternalDataSource ? (
          <button
            type="button"
            className="btn btn-xs"
            disabled={true}
            style={{ cursor: 'not-allowed' }}
          >
            <i className="wb webconnect-trash-solid"> </i>
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-xs btn-theme-delete"
            style={{ cursor: deleteFlag ? 'pointer' : 'not-allowed' }}
            onClick={deleteFlag ? deleteEnvConstant : undefined}
          >
            <i className="wb webconnect-trash-solid"> </i>&nbsp;
            {deleteFlag ? null : (
              <TooltipInfo
                title={description}
                headerText={`Permission Disabled!`}
                showHeader={true}
                showArrow={true}
              />
            )}
          </button>
        )}
      </td>
    </tr>
  );
};

export default ShowEnvConstantTable;
